import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
// import Image from "next/legacy/image";
import { StructuredText, Image } from "react-datocms";

const isServer = typeof window === "undefined";
const OwlCarousel = !isServer ? dynamic(import("react-owl-carousel")) : null;

const LinkUI = dynamic(() => import("@/common/UI/Link"));
const Text = dynamic(() => import("@/common/UI/Text"));

import { getSlugURL } from "@/utils/functions";

function MainSlider(props) {
  const { sliderData, labelsList } = props;
  const [showData, setShowData] = useState(false);

  const options = {
    loop: true,
    margin: 0,
    nav: true,
    dots: false,
    items: 1,
    lazyLoad: true,
    lazyLoadEager: 3,
    autoplay: sliderData?.length > 1 ? true : false,
    responsive: {},
  };

  useEffect(() => {
    sliderData?.length > 0 && labelsList ? setShowData(true) : null;
  }, [labelsList, sliderData]);

  useEffect(() => {
    if (showData) {
      setTimeout(() => {
        let owlNav = document.querySelector(".owl-nav");
        owlNav ? owlNav.classList.add("container") : null;
      }, 1000);
    }
  }, [showData]);

  return (
    <>
      {showData ? (
        <>
          <OwlCarousel
            className="owl-carousel owl-theme main-slider-carousel"
            {...options}
          >
            {sliderData?.map((item, index) => {
              return (
                <div
                  key={index}
                  className="h-[400px] before:bg-[#0d3c67d1] before:absolute before:h-full before:w-full before:top-0 before:left-0 before:z-10 "
                >
                  <Image
                    data={{
                      ...item?.gallery[0].responsiveImage,
                      alt: `Cover Image for ${item?.gallery[0]?.alt}`,
                    }}
                    alt={`Cover Image for ${item?.gallery[0]?.alt}`}
                    title={`Cover Image for ${item?.gallery[0]?.title}`}
                    lazyLoad={true}
                    fadeInDuration={10}
                    priority={true}
                    className="object-set"
                  />

                  <div className="container absolute inset-0 py-16 z-20">
                    <div className="z-1 text-white mb-16 md:mb-20 xl:mb-28 relative md:w-3/4 xl:w-2/4">
                      <Text variant="h1" className="h1-web text-white mb-0">
                        {item?.title}
                      </Text>
                      <h3 className="h3-web mt-4 mb-8 structure-format text-white">
                        <StructuredText data={item?.abstract} />
                      </h3>
                      {labelsList?.more && (
                        <LinkUI
                          href={
                            item?.linkTo
                              ? getSlugURL(item?.linkTo)
                              : item?.externalLink
                              ? item?.externalLink
                              : "#!"
                          }
                          className="uppercase border-2 h6-web px-10 text-[0.875rem] tracking-[0.2em] py-2.5 rounded-full"
                        >
                          {labelsList?.more}
                        </LinkUI>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </OwlCarousel>
        </>
      ) : (
        <div className="rounded-md px-16 py-8 max-w-full w-full mx-auto">
          <div className="animate-pulse flex space-x-4">
            <div className="flex-1 space-y-4">
              <div className="space-y-4">
                {[...Array(12)].map((x, i) => (
                  <div key={i} className="h-4 bg-[#a0cffb] rounded"></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default MainSlider;
